var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.36,
    height: 33.12,
    viewBox: "0 0 27.36 33.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-post-box",
    "data-name": "Icon map-post-box",
    d: "M20.879,3.253a9.273,9.273,0,0,0-9.359,9.294V34.56h3.6v-7.2H26.64v7.2h3.6V12.547a9.272,9.272,0,0,0-9.361-9.294ZM2.88,1.44l5.3,8.64h.553A9.4,9.4,0,0,1,15.12,2.191V1.44Z",
    transform: "translate(-2.88 -1.44)",
    fill: "#e3e3e3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostBox);
export default __webpack_public_path__ + "static/media/postBox.3f814242021bdc5ee88bbf9b32859a0f.svg";
export { ForwardRef as ReactComponent };